// File: useMentorProfile.js
import apiClient from 'src/Common/apiClient'

export const fetchProfileData = async (token) => {
  try {
    const response = await apiClient.get(`/Mentor/Profile`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    return response.data
  } catch (error) {
    console.error('Error fetching profile data:', error)
    throw error
  }
}

export const updateProfileData = async (formData, token) => {
  try {
    const response = await apiClient.post('/Mentor/Profile', formData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    return response
  } catch (error) {
    console.error('Error updating profile data:', error)
    throw error
  }
}

export const fetchSkillsByExpertise = async (expertiseAreaId, token) => {
  try {
    const response = await apiClient.get(`/Skill/GetAllSkills?expertiseAreaId=${expertiseAreaId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    // api-dev2: tolerate a paginated ({ items }) list.
    const d = response.data
    return Array.isArray(d) ? d : d?.items ?? []
  } catch (error) {
    console.error('Error fetching skills by expertise area:', error)
    throw error
  }
}
